import * as React from 'react';
import {connect} from 'react-redux';
import {
    createBusinessObjectRelationship,
    deleteBusinessObjectRelationship,
    updateBusinessObjectRelationship
} from '../../../actions/boCoreActions';
import {FilterXSS} from "xss";
import * as toastr from "toastr";
import {DataTypesEnum} from "../enums/dataTypesEnum";
import {BusinessObject} from "../models/BusinessObject";
import {Relationship} from "../models/Relationship";
import BusinessObjects from "../../../views/bo-core/BusinessObjects";
import {stringComparator} from "../common/slickGridComparators";
import {EVENTS} from "../../../config/boCore";
import Utils from "../../../Utils";

interface Props {
    currentRelationship: any;
    currentBusinessObject: any;
    businessObjectsWrapper: any;

    createBusinessObjectRelationship(dto: any, args: any): void;

    deleteBusinessObjectRelationship(id: number, dto: any): void;

    updateBusinessObjectRelationship(id: number, dro: any, args: any): void;
}

const lastEditableCol = 4, firstEditableCol = 1;
const myxss = new FilterXSS({
    whiteList: {}
});
declare const Slick: any;

class BusinessObjectRelationshipsGrid extends React.Component<Props> {
    constructor(props) {
        super(props);
    };

    UNSAFE_componentWillMount() {
        $(document.body)
            .unbind(EVENTS.boView.relationshipsGrid.open)
            .unbind(EVENTS.boView.relationshipsGrid.create)
            .unbind(EVENTS.boView.relationshipsGrid.update)
            .unbind(EVENTS.boView.relationshipsGrid.delete)
            .on(EVENTS.boView.relationshipsGrid.open, (event: any) => {
                this.buildGrid(this.props.currentBusinessObject);
                event.preventDefault();
            })
            .on(EVENTS.boView.relationshipsGrid.create, (event: any) => {
                const grid = $("#BusinessObjectRelationshipsGrid").data("gridInstance");
                const dataView = grid.getData();
                const businessObject = event.args.businessObject;
                const relationship = businessObject.getRelationship(event.args.id).clone();
                relationship.setPrototype("groupName", relationship.fromBoClass.name);

                dataView.beginUpdate();
                dataView.deleteItem(-1);
                dataView.insertItem(0, relationship);
                dataView.endUpdate();

                if (event.args.withNewRow) {
                    addNewRow(dataView, businessObject);
                    setTimeout(() => {
                        grid.setSelectedRows([dataView.getRowById(-1)]);
                        grid.setActiveCell(dataView.getRowById(-1), 1);
                    }, 1);
                } else {
                    const row = dataView.getRowById(event.args.id);
                    setTimeout(() => {
                        grid.setSelectedRows([row]);
                        BusinessObject.enableButton("relationship-new-btn", "");
                    }, 1);
                }

                Utils.eventDispatcher(EVENTS.boView.setBusinessObject, {
                    businessObject: businessObject.clone()
                });

                event.preventDefault();
            })
            .on(EVENTS.boView.relationshipsGrid.update, (event: any) => {
                const grid = $("#BusinessObjectRelationshipsGrid").data("gridInstance");
                const relationship = event.args.relationship;
                const currentRelationship = this.props.currentBusinessObject.getRelationship(relationship.id);
                currentRelationship.name = relationship.name;
                currentRelationship.inward = relationship.inward;
                currentRelationship.outward = relationship.outward;
                currentRelationship.toBoClass = relationship.toBoClass;
                currentRelationship.fromBoClass = relationship.fromBoClass;
                currentRelationship.systemRequired = relationship.systemRequired;
                event.preventDefault();
                setTimeout(() => {
                    grid.setSelectedRows(grid.getSelectedRows());
                }, 1);
            })
            .on(EVENTS.boView.relationshipsGrid.delete, (event: any) => {
                this.props.currentBusinessObject.deleteRelationship(event.args.id);
                const grid = $("#BusinessObjectRelationshipsGrid").data("gridInstance");
                const dataView = grid.getData();
                const row = dataView.getRowById(event.args.id);
                dataView.beginUpdate();
                dataView.deleteItem(event.args.id);
                dataView.endUpdate();
                grid.invalidateRow(row);
                event.preventDefault();
                setTimeout(() => {
                    grid.setSelectedRows([row]);
                    grid.render();
                }, 1);
            })

    }

    buildGrid = (businessObject) => {
        let grid, dataView;
        const data = businessObject.getRelationships(DataTypesEnum.ARRAY).map(item => item.clone());
        data.forEach(item => {
            item.setPrototype("groupName", item.fromBoClass.name)
        });
        let columnFilters = {};

        let radioSelector = new Slick.RadioSelectColumn({
            cssClass: "slick-cell-checkboxsel",
            columnId: "relationship-grid-checkbox"
        });
        const columns = [
            radioSelector.getColumnDefinition(),
            {
                id: "toBoClass",
                name: "Relationship To Type",
                field: "toBoClass",
                width: 100,
                minWidth: 50,
                sortable: true,
                editor: ToBoClassEditor,
                formatter: ToBoClassFormatter,
                dataSource: Array.from(this.props.businessObjectsWrapper.getBusinessObjects(DataTypesEnum.ARRAY))
            },
            {
                id: "name",
                name: "Name",
                field: "name",
                width: 100,
                minWidth: 50,
                sortable: true,
                editor: TextEditor
            },
            {
                id: "inward",
                name: "Relationship Forward",
                field: "inward",
                width: 100,
                minWidth: 50,
                sortable: true,
                editor: TextEditor
            },
            {
                id: "outward",
                name: "Reverse Relationship",
                field: "outward",
                width: 100,
                minWidth: 50,
                sortable: true,
                editor: TextEditor
            },
            {
                id: "systemRequired",
                name: "System Required",
                field: "systemRequired",
                width: 90,
                sortable: true,
                resizable: false,
                editor: SwitchEditor
            },
        ];

        /**
         * @return {string}
         */
        function ToBoClassFormatter(row, cell, value) {
            if (value) {
                return myxss.process(value.name);
            }
        }

        const options = {
            enableCellNavigation: true,
            enableColumnReorder: false,
            forceFitColumns: true,
            multiColumnSort: false,
            editable: true,
            showHeaderRow: true,
            headerRowHeight: 30,
            autoEdit: true,
            asyncEditorLoading: false,
            explicitInitialization: true
        };

        function filter(item) {
            const keys = Object.keys(columnFilters);
            for (let i = 0; i < keys.length; i++) {
                if (keys[i] !== undefined && columnFilters[keys[i]] !== "") {
                    const c = grid.getColumns()[grid.getColumnIndex(keys[i])];
                    if (!item[c.field].toString().toLowerCase().includes(columnFilters[keys[i]].toString().toLowerCase())) {
                        return false;
                    }
                }
            }
            return true;
        }

        const getCurrentBusinessObject = () => {
            return this.props.currentBusinessObject;
        };

        const getCurrentRelationship = () => {
            return this.props.currentRelationship;
        };

        function SwitchEditor(args) {
            let $input, defaultValue;
            this.init = function () {
                $input = Utils.$("<input id='toggle-one' type='checkbox' data-onstyle='primary' data-offstyle='danger' data-toggle='toggle' data-size='mini'/>");
                $input.appendTo(args.container);
                $input.focus().select();
                $input.width($input.width());
                $input.keydown(function (e) {
                    if (e.keyCode === Utils.$.ui.keyCode.LEFT || e.keyCode === Utils.$.ui.keyCode.RIGHT) {
                        e.stopImmediatePropagation();
                    }
                });

                $input.prop('checked', args.item[args.column.field]);

                $input.bootstrapToggle({
                    on: 'true',
                    off: 'false'
                });

                $input.change(function () {
                    const currentRelationship = getCurrentRelationship();
                    const currentBusinessObject = getCurrentBusinessObject();
                    const originalRelationship = currentBusinessObject.getRelationship(currentRelationship.id);
                    if (originalRelationship && originalRelationship.systemRequired && !$input[0].checked) {
                        Utils.$.confirm({
                            title: 'Confirm?',
                            keyboardEnabled: true,
                            escapeKey: 'cancel',
                            backgroundDismiss: false,
                            content: 'Unlocking this Relationship may cause problem with some functionalities. Are you sure you want to continue?',
                            type: 'red',
                            theme: 'dark',
                            typeAnimated: false,
                            buttons: {
                                ok: {
                                    text: "Yes!",
                                    btnClass: 'btn-danger',
                                    keys: ['enter'],
                                    action: () => {
                                        setRequired();
                                        saveBOClassRelationship(false);
                                    }
                                },
                                cancel: function () {
                                    $input.bootstrapToggle("toggle")
                                }
                            }
                        });
                    } else {
                        setRequired()
                    }

                    function setRequired() {
                        currentRelationship[args.column.id] = $input[0].checked;
                        const result = currentBusinessObject.checkRelationshipsBeforeSave(currentRelationship);
                        BusinessObjects.appendQtipsToNode(result.data, grid, $("#relationship-save-btn"));
                        if (!result.valid) {
                            BusinessObject.disableButton("relationship-save-btn");
                            return;
                        }
                        BusinessObject.enableButton("relationship-save-btn", "");
                    }
                });

                this.focus = function () {
                    $input.focus();
                };
                this.destroy = function () {
                    $(args.container).empty();
                };
                this.isValueChanged = function () {
                    return args.item.input !== $input.val()
                };
                this.loadValue = function (item) {
                    defaultValue = item[args.column.field];
                    $input.val(defaultValue);
                    $input.select();
                };
                this.serializeValue = function () {
                    return {input: $input.val()}
                };
                this.applyValue = function (item) {
                    item[args.column.field] = $input[0].checked;
                };
                this.validate = function () {
                    return {valid: true, msg: null}
                };
            };
            this.init();
        }

        function TextEditor(args) {
            let $input, defaultValue;
            this.init = function () {
                $input = $(`<input type=text class='editor-text rounded' />`);
                $input.appendTo(args.container);
                $input.focus().select();
                $input.width($input.width());
                $input.keydown(function (e) {
                    if (e.keyCode === Utils.$.ui.keyCode.LEFT || e.keyCode === Utils.$.ui.keyCode.RIGHT) {
                        e.stopImmediatePropagation();
                    }
                });

                $input.keyup(function (e) {
                    const currentRelationship = getCurrentRelationship();
                    const currentBusinessObject = getCurrentBusinessObject();
                    currentRelationship[args.column.id] = e.target.value;

                    const result = currentBusinessObject.checkRelationshipsBeforeSave(currentRelationship);
                    BusinessObjects.appendQtipsToNode(result.data, grid, $("#relationship-save-btn"));
                    if (!result.valid) {
                        BusinessObject.disableButton("relationship-save-btn");
                        return;
                    }
                    BusinessObject.enableButton("relationship-save-btn", "");
                });

                this.focus = function () {
                    $input.focus();
                };
                this.destroy = function () {
                    $(args.container).empty();
                };
                this.isValueChanged = function () {
                    return (!($input.val() === "" && defaultValue == null)) && ($input.val() !== defaultValue);
                };
                this.loadValue = function (item) {
                    defaultValue = item[args.column.field] || "";

                    $input.val(defaultValue);
                    $input[0].defaultValue = defaultValue;
                    $input.select();
                };
                this.serializeValue = function () {
                    return {input: $input.val()}
                };
                this.applyValue = function (item) {
                    const currentRelationship = getCurrentRelationship();
                    item[args.column.field] = currentRelationship[args.column.field];
                };
                this.validate = function () {
                    return {valid: true, msg: undefined};
                };

            };
            this.init();
        }

        function ToBoClassEditor(args) {
            let $input, defaultValue;
            this.keyCaptureList = [Slick.keyCode.UP, Slick.keyCode.DOWN, Slick.keyCode.ENTER];
            this.init = function () {
                $input = $('<select/>');
                $input.appendTo(args.container);
                PopulateSelect($input[0], args.column.dataSource, true);
                $input.keydown(function (e) {
                    if (e.keyCode === Utils.$.ui.keyCode.LEFT || e.keyCode === Utils.$.ui.keyCode.RIGHT) {
                        e.stopImmediatePropagation();
                    }
                });
                $input.select2({
                    width: $(args.container).width(),
                    placeholder: 'Select Business Object',
                    allowClear: true,
                    theme: "default",
                });
                $input.select2("open");

                $input.change(function (e) {
                        try {
                            const currentRelationship = getCurrentRelationship();
                            const currentBusinessObject = getCurrentBusinessObject();
                            JSON.parse(e.target.value);
                            currentRelationship.toBoClass = JSON.parse(e.target.value);
                            const result = currentBusinessObject.checkRelationshipsBeforeSave(currentRelationship);
                            BusinessObjects.appendQtipsToNode(result.data, grid, $("#relationship-save-btn"));
                            if (!result.valid) {
                                BusinessObject.disableButton("relationship-save-btn");
                                return
                            }
                            BusinessObject.enableButton("relationship-save-btn", "");
                        } catch (e) {

                        }
                    }
                );
                this.focus = function () {
                    $input.focus();
                };
                this.destroy = function () {
                    $input.select2('destroy');
                    $input.remove();
                };
                this.isValueChanged = function () {
                    return (!($input.val() === "" && defaultValue == null)) && ($input.val() !== defaultValue);
                };
                this.loadValue = function () {
                    const item = args.item[args.column.id];
                    if (item) {
                        defaultValue = JSON.stringify({id: item.id, name: item.name, description: item.description});
                    }
                    $input.val(defaultValue).trigger('change.select2');
                };
                this.serializeValue = function () {
                    return {input: $input.val()}
                };
                this.applyValue = function (item) {
                    const currentRelationship = getCurrentRelationship();
                    item[args.column.field] = currentRelationship.toBoClass
                };
                this.validate = function () {
                    return {valid: true, msg: undefined};
                };
            };
            this.init();
        }

        function attachAutoResizeDataGrid(grid, gridId) {
            const gridDomElm = $('#' + gridId);
            if (!gridDomElm || typeof gridDomElm.offset() === "undefined") {
                return null;
            }
            if ($(document.body).hasClass("mini-navbar")) {
                resizeToFitBrowserWindow(grid, gridId, true);
            } else {
                resizeToFitBrowserWindow(grid, gridId, false);
            }
            $("#hide-nav-btn").on("click", function () {
                if (!$(document.body).hasClass("mini-navbar")) {
                    resizeToFitBrowserWindow(grid, gridId, true);
                } else {
                    resizeToFitBrowserWindow(grid, gridId, false);
                }
            });
            $(window).on("resize", function () {
                if ($(document.body).hasClass("mini-navbar")) {
                    resizeToFitBrowserWindow(grid, gridId, true);
                } else {
                    resizeToFitBrowserWindow(grid, gridId, false);
                }
            });
        }

        function calculateNewDimensions(printMode, minNavBarEnabled) {
            const $accordion = $("#accordeon");
            if (minNavBarEnabled) {
                return {
                    height: $accordion.height() - 70,
                    width: "100%"
                };
            }
            return {
                height: $accordion.height() - 70,
                width: "100%"
            };
        }

        function resizeToFitBrowserWindow(grid, gridId, minNavBarEnabled) {
            const newSizes = calculateNewDimensions(null, minNavBarEnabled);
            $('#' + gridId)
                .height(newSizes.height)
                .width(newSizes.width);

            if (new RegExp('MSIE [6-8]').exec(navigator.userAgent) === null && grid) {
                grid.resizeCanvas();
            }
        }

        const saveBOClassRelationship = (withNewRow) => {
            const row = grid.getSelectedRows()[0];
            const item = dataView.getItem(row);
            if (item) {
                const currentRelationship = getCurrentRelationship();
                const currentBusinessObject = getCurrentBusinessObject();

                const result = currentBusinessObject.checkRelationshipsBeforeSave(currentRelationship);
                if (result.valid) {
                    if (grid.getEditorLock().isActive()) {
                        grid.getEditorLock().commitCurrentEdit();
                    }
                    if (currentRelationship.id === -1) {
                        const dto = {
                            name: currentRelationship.name,
                            inward: currentRelationship.inward,
                            outward: currentRelationship.outward,
                            fromBoClass: currentRelationship.fromBoClass,
                            toBoClass: currentRelationship.toBoClass,
                            systemRequired: currentRelationship.systemRequired
                        };
                        this.props.createBusinessObjectRelationship(dto, {
                            event: EVENTS.boView.relationshipsGrid.create,
                            boClass: currentBusinessObject,
                            withNewRow: withNewRow
                        });
                    } else {
                        const dto = {
                            name: currentRelationship.name,
                            inward: currentRelationship.inward,
                            outward: currentRelationship.outward,
                            systemRequired: currentRelationship.systemRequired
                        };
                        this.props.updateBusinessObjectRelationship(currentRelationship.id, dto, {
                            event: EVENTS.boView.relationshipsGrid.update,
                            boClass: currentBusinessObject
                        });
                    }
                } else {
                    BusinessObjects.appendQtipsToNode(result.data, grid, $("#relationship-save-btn"));
                }
            }
        };

        function groupByFromType() {
            dataView.setGrouping({
                getter: "groupName",
                formatter: function (g) {
                    return `Relationship From Type: ${myxss.process(g.value)}<span style='color:green'> (${g.count})</span>`;
                },
                collapsed: false,
                aggregateCollapsed: true,
                lazyTotalsCalculation: true
            });
        }

        function removeFilters() {
            columnFilters = {};
            let header = grid.getHeaderRow();
            $(header).children('div').each(function (index, element) {
                if (index !== 0) {
                    $(element).children().val("");
                }

            });
        }

        $(() => {
            const $businessObjectRelationshipsGrid = $("#BusinessObjectRelationshipsGrid");
            const groupItemMetadataProvider = new Slick.Data.GroupItemMetadataProvider();
            dataView = new Slick.Data.DataView();
            dataView.beginUpdate();
            dataView.setItems(data);
            dataView.setFilter(filter);
            groupByFromType();
            dataView.endUpdate();

            if ($businessObjectRelationshipsGrid[0]) {
                grid = new Slick.Grid("#BusinessObjectRelationshipsGrid", dataView, columns, options);
                $businessObjectRelationshipsGrid.data("gridInstance", grid);
                grid.registerPlugin(groupItemMetadataProvider);
                grid.registerPlugin(radioSelector);

                grid.onSort.subscribe(function (e, args) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    const currentRelationship = getCurrentRelationship();
                    const currentBusinessObject = getCurrentBusinessObject();
                    if (currentRelationship) {
                        if (currentBusinessObject.hasRelationship(currentRelationship.id)) {
                            const relationship = currentBusinessObject.getRelationship(currentRelationship.id);
                            if (!relationship.equal(currentRelationship)) {
                                confirm(relationship);
                            } else {
                                sort()
                            }
                        } else {
                            confirm();
                        }
                    } else {
                        sort();
                    }

                    function confirm(relationship?: any) {
                        Utils.$.confirm({
                            title: 'Confirm?',
                            keyboardEnabled: true,
                            escapeKey: 'cancel',
                            backgroundDismiss: false,
                            content: 'There are unsaved changes. Are you sure you want to continue?',
                            type: 'red',
                            theme: 'dark',
                            typeAnimated: false,
                            buttons: {
                                ok: {
                                    text: "Yes!",
                                    btnClass: 'btn-danger',
                                    keys: ['enter'],
                                    action: () => {
                                        if (grid.getEditorLock().isActive()) {
                                            grid.getEditorLock().cancelCurrentEdit();
                                        }
                                        if (relationship) {
                                            currentRelationship.name = relationship.name;
                                            currentRelationship.inward = relationship.inward;
                                            currentRelationship.outward = relationship.outward;
                                            currentRelationship.systemRequired = relationship.systemRequired;
                                        } else {
                                            dataView.beginUpdate();
                                            dataView.deleteItem(-1);
                                            Utils.eventDispatcher(EVENTS.boView.setRelationship, {
                                                relationship: null
                                            });
                                            dataView.endUpdate();
                                            grid.setSelectedRows([]);
                                            BusinessObject.enableButton("relationship-new-btn");
                                        }
                                        sort();
                                    }
                                },
                                cancel: function () {

                                }
                            }
                        });
                    }

                    function sort() {
                        const sortCol = args.sortCol;
                        dataView.sort(function (dataRow1, dataRow2) {
                            const field = sortCol.field;
                            const sign = args.sortAsc ? 1 : -1;

                            const value1 = dataRow1[field];
                            const value2 = dataRow2[field];
                            return stringComparator(value1, value2, sign);
                        });
                        grid.invalidate();
                        grid.updateRowCount();
                        grid.resizeCanvas();
                        grid.render();
                    }
                });

                dataView.onRowCountChanged.subscribe(function () {
                    grid.updateRowCount();
                    grid.render();
                });

                dataView.onRowsChanged.subscribe(function (e, args) {
                    grid.invalidateRows(args.rows);
                    grid.render();
                });

                Utils.$(grid.getHeaderRow()).unbind();
                Utils.$(grid.getHeaderRow()).delegate(":input", "keyup search", function () {
                    const columnId = $(this).data("columnId");
                    if (columnId != null) {
                        const currentRelationship = getCurrentRelationship();
                        const currentBusinessObject = getCurrentBusinessObject();
                        if (currentRelationship) {
                            if (currentBusinessObject.hasRelationship(currentRelationship.id)) {
                                const relationship = currentBusinessObject.getRelationship(currentRelationship.id);
                                if (!relationship.equal(currentRelationship)) {
                                    Utils.$.confirm({
                                        title: 'Confirm?',
                                        keyboardEnabled: true,
                                        escapeKey: 'cancel',
                                        backgroundDismiss: false,
                                        content: 'There are unsaved changes. Are you sure you want to continue?',
                                        type: 'red',
                                        theme: 'dark',
                                        typeAnimated: false,
                                        buttons: {
                                            ok: {
                                                text: "Yes!",
                                                btnClass: 'btn-danger',
                                                keys: ['enter'],
                                                action: () => {
                                                    if (grid.getEditorLock().isActive()) {
                                                        grid.getEditorLock().cancelCurrentEdit();
                                                    }

                                                    currentRelationship.name = relationship.name;
                                                    currentRelationship.inward = relationship.inward;
                                                    currentRelationship.outward = relationship.outward;
                                                    currentRelationship.systemRequired = relationship.systemRequired;

                                                    columnFilters[columnId] = Utils.$.trim($(this).val());
                                                    dataView.refresh();
                                                    grid.invalidate();
                                                    grid.render();
                                                }
                                            },
                                            cancel: function () {
                                            }
                                        }
                                    });
                                } else {
                                    columnFilters[columnId] = Utils.$.trim($(this).val());
                                    dataView.refresh();
                                }
                            }
                        } else {
                            columnFilters[columnId] = Utils.$.trim($(this).val());
                            dataView.refresh();
                        }
                    }
                });

                grid.onHeaderRowCellRendered.subscribe(function (e, args) {
                    $(args.node).empty();
                    if (args.column.id !== "relationship-grid-checkbox") {
                        $(`<input class=rounded type='search' placeholder="🔍">`)
                            .data("columnId", args.column.id)
                            .val(columnFilters[args.column.id])
                            .appendTo(args.node);
                    }
                });

                grid.onSelectedRowsChanged.subscribe((e) => {
                    const row = grid.getSelectedRows()[0];
                    const item = dataView.getItem(row);
                    if (item) {
                        try {
                            Utils.eventDispatcher(EVENTS.boView.setRelationship, {
                                relationship: item.clone()
                            });
                        } catch (e) {
                            console.error(item)
                        }
                    } else {
                        Utils.eventDispatcher(EVENTS.boView.setRelationship, {
                            relationship: null
                        });
                    }
                    BusinessObject.disableButton("relationship-save-btn");
                    Utils.$(".qtip").remove();
                    Utils.$('[data-hasqtip]').qtip('destroy', true);
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                });

                grid.onBeforeRowChange = function (e, args) {
                    const currentRelationship = getCurrentRelationship();
                    const currentBusinessObject = getCurrentBusinessObject();
                    if (currentRelationship) {
                        if (currentBusinessObject.hasRelationship(currentRelationship.id)) {
                            const relationship = currentBusinessObject.getRelationship(currentRelationship.id);
                            if (!relationship.equal(currentRelationship)) {
                                Utils.$.confirm({
                                    title: 'Confirm?',
                                    keyboardEnabled: true,
                                    escapeKey: 'cancel',
                                    backgroundDismiss: false,
                                    content: 'There are unsaved changes. Are you sure you want to continue?',
                                    type: 'red',
                                    theme: 'dark',
                                    typeAnimated: false,
                                    buttons: {
                                        ok: {
                                            text: "Yes!",
                                            btnClass: 'btn-danger',
                                            keys: ['enter'],
                                            action: () => {
                                                if (grid.getEditorLock().isActive()) {
                                                    grid.getEditorLock().cancelCurrentEdit();
                                                }
                                                currentRelationship.name = relationship.name;
                                                currentRelationship.inward = relationship.inward;
                                                currentRelationship.outward = relationship.outward;
                                                currentRelationship.systemRequired = relationship.systemRequired;

                                                const item = currentRelationship.clone();
                                                item.setPrototype("groupName", item.fromBoClass.name);
                                                dataView.beginUpdate();
                                                dataView.updateItem(item.id, item);
                                                dataView.endUpdate();

                                                grid.setSelectedRows([args.row]);
                                                grid.setActiveCell(args.row, args.cell);
                                            }
                                        },
                                        cancel: function () {

                                        }
                                    }
                                });
                                e.preventDefault();
                                e.stopImmediatePropagation();
                            }
                        } else {
                            Utils.$.confirm({
                                title: 'Confirm?',
                                keyboardEnabled: true,
                                escapeKey: 'cancel',
                                backgroundDismiss: false,
                                content: 'There are unsaved changes. Are you sure you want to continue?',
                                type: 'red',
                                theme: 'dark',
                                typeAnimated: false,
                                buttons: {
                                    ok: {
                                        text: "Yes!",
                                        btnClass: 'btn-danger',
                                        keys: ['enter'],
                                        action: () => {
                                            if (grid.getEditorLock().isActive()) {
                                                grid.getEditorLock().cancelCurrentEdit();
                                            }
                                            dataView.beginUpdate();
                                            dataView.deleteItem(-1);
                                            dataView.endUpdate();
                                            grid.setSelectedRows([args.row - 1]);
                                            grid.setActiveCell(args.row - 1, args.cell);
                                            BusinessObject.enableButton("relationship-new-btn");
                                        }
                                    },
                                    cancel: function () {

                                    }
                                }
                            });
                            e.preventDefault();
                            e.stopImmediatePropagation();
                        }
                    }
                };

                grid.onBeforeEditCell.subscribe(function (e, args) {
                    const currentRelationship = getCurrentRelationship();
                    const currentBusinessObject = getCurrentBusinessObject();
                    const originalRelationship = currentRelationship ? currentBusinessObject.getRelationship(currentRelationship.id) : null;
                    if (args.item.id !== -1 && args.column.field === "toBoClass") {
                        return false;
                    }
                    if (args.column.field !== "systemRequired" && (originalRelationship && originalRelationship.systemRequired)) {
                        toastr.warning("The Business Object Relationship you are trying to edit is required for the system. Please set System Required to false and save it to continue editing.");
                        return false;
                    }
                    return true;
                });

                grid.onKeyDown.subscribe(function (event) {
                    if (event.keyCode === 9 && event.shiftKey === false) {
                        if (grid.getActiveCell().cell === lastEditableCol) {
                            if (!$("#relationship-save-btn").prop("disabled")) {
                                saveBOClassRelationship(true);
                            } else {
                                grid.gotoCell(grid.getActiveCell().row, firstEditableCol, true);
                            }
                            event.stopImmediatePropagation();
                        }
                    }
                    if (event.keyCode === 9 && event.shiftKey === true) {
                        if (grid.getActiveCell().cell === firstEditableCol) {
                            grid.gotoCell(grid.getActiveCell().row, lastEditableCol, true);
                            event.stopImmediatePropagation();
                        }
                    }
                    if (event.keyCode === 13) {
                        grid.getEditController().commitCurrentEdit();
                        event.stopImmediatePropagation();
                    }
                });

                grid.onClick.subscribe(function (e, args) {
                    if (grid.getEditorLock().isActive()) {
                        grid.getEditorLock().commitCurrentEdit();
                    }
                    const row = grid.getSelectedRows()[0];
                    if (row !== args.row) {
                        grid.setSelectedRows([args.row]);
                    }
                });

                grid.onValidationError.subscribe(function (e, args) {
                    toastr.warning(args.validationResults.msg);
                });

                $("#relationship-new-btn")
                    .unbind()
                    .click(() => {
                        removeFilters();
                        let relationship = dataView.getItem(0);
                        if (relationship && relationship.id === -1) {
                            toastr.warning("There is already a blank line.");
                            BusinessObject.disableButton("relationship-new-btn");
                            return;
                        }
                        addNewRow(dataView, getCurrentBusinessObject());
                        grid.setSelectedRows([dataView.getRowById(-1)]);
                        grid.setActiveCell(dataView.getRowById(-1), 1);
                    });

                $("#relationship-save-btn")
                    .unbind()
                    .click(() => {
                        if (!$("#relationship-save-btn").prop("disabled")) {
                            saveBOClassRelationship(false);
                        }
                    });

                $("#relationship-delete-btn")
                    .unbind()
                    .click(() => {
                        const row = grid.getSelectedRows()[0];
                        const item = dataView.getItem(row);
                        if (item) {
                            const currentRelationship = getCurrentRelationship();
                            const currentBusinessObject = getCurrentBusinessObject();
                            if (currentBusinessObject.hasRelationship(currentRelationship.id)) {
                                const isErasable = currentRelationship.isErasable();
                                if (!isErasable.erasable) {
                                    toastr.warning(isErasable.msg);
                                    return;
                                }
                                Utils.$.confirm({
                                    title: 'Confirm?',
                                    keyboardEnabled: true,
                                    escapeKey: 'cancel',
                                    backgroundDismiss: false,
                                    content: 'You are about to delete one relationship, this procedure is irreversible.',
                                    type: 'red',
                                    theme: 'dark',
                                    typeAnimated: false,
                                    buttons: {
                                        ok: {
                                            text: "Yes!",
                                            btnClass: 'btn-danger',
                                            keys: ['enter'],
                                            action: () => {
                                                this.props.deleteBusinessObjectRelationship(currentRelationship.id, {
                                                    event: EVENTS.boView.relationshipsGrid.delete,
                                                    fromBoClass: currentRelationship.fromBoClass,
                                                    toBoClass: currentRelationship.toBoClass
                                                });
                                                BusinessObject.disableButton("relationship-delete-btn");
                                            }
                                        },
                                        cancel: function () {
                                        }
                                    }
                                });
                            } else {
                                const row = dataView.getRowById(currentRelationship.id);
                                dataView.beginUpdate();
                                dataView.deleteItem(currentRelationship.id);
                                dataView.endUpdate();
                                grid.invalidateRow(row);
                                grid.setSelectedRows([1]);
                                grid.render();
                                BusinessObject.enableButton("relationship-new-btn");
                            }
                        }
                    });

                new Slick.Controls.ColumnPicker(columns, grid, options);
                grid.setSelectionModel(new Slick.RowSelectionModel({selectActiveRow: false}));
                dataView.syncGridSelection(grid, true, false);
                grid.init();
                if (dataView.getLength() === 0) {
                    addNewRow(dataView, businessObject);
                }
                attachAutoResizeDataGrid(grid, "BusinessObjectRelationshipsGrid");
                BusinessObject.enableButton("relationship-new-btn");
            }
        });
    };

    render() {
        const {currentBusinessObject} = this.props;
        if (!currentBusinessObject) return null;
        const forward = {bo: "...", relation: "..."}, reverse = {bo: "...", relation: "..."};
        const grid = $("#BusinessObjectRelationshipsGrid").data("gridInstance");
        if (grid) {
            const row = grid.getSelectedRows()[0];
            const dataView = grid.getData();
            const item = dataView.getItem(row);
            if (item instanceof Relationship) {
                forward.bo = item.fromBoClass.name;
                forward.relation = item.inward;
                reverse.bo = item.toBoClass.name;
                reverse.relation = item.outward;
            }
        }

        return (
            <div>
                <div className="bo-core-header background-gradient" style={{marginBottom: 5, paddingTop: 5}}>
                    <label style={
                        {
                            marginLeft: 2,
                            float: "left",
                            color: "#FFFFFF",
                            paddingTop: 7,
                            fontSize: 18,
                            width: "calc(100% - 190px)",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden"
                        }
                    }
                           title={`Type: ${currentBusinessObject.name}`}
                    >
                        {`Type: ${currentBusinessObject.name}`}
                    </label>
                    <div style={{width: 185, float: "right"}}>
                        <button style={{marginRight: 2, height: 36}} id="relationship-new-btn"
                                className="btn btn-success">New
                        </button>
                        <button style={{marginRight: 2, height: 36}} disabled id="relationship-save-btn"
                                className="btn btn-primary">Save
                        </button>
                        <button style={{marginRight: 2, height: 36}} id="relationship-delete-btn"
                                className="btn btn-danger">Delete
                        </button>
                    </div>
                </div>
                <div className="custom-header" style={{border: "0px", backgroundColor: "#FFFFFF"}}
                     id="BusinessObjectRelationshipsGrid"/>
                <div style={{backgroundColor: "#F3F3F4", height: 20, marginTop: 2}}>
                    <label style={{paddingLeft: 2}}>
                        <span
                            style={{paddingTop: 3}}>Relationship Forward: {forward.bo} {forward.relation} {reverse.bo}</span>
                        <span
                            style={{paddingTop: 3}}> | Reverse Relationship: {reverse.bo} {reverse.relation} {forward.bo}</span>
                    </label>
                </div>
            </div>
        )
    };
}

function addNewRow(dataView, boClass) {
    const item = new Relationship(-1, "n/a", "n/a", "n/a", {
        id: boClass.id,
        name: boClass.name,
        description: boClass.description
    }, {
        id: -1,
        name: "",
        description: ""
    }, false);
    item.setPrototype("groupName", boClass.name);
    dataView.beginUpdate();
    dataView.insertItem(0, item);
    dataView.endUpdate();
    BusinessObject.disableButton("relationship-new-btn");
}

function PopulateSelect(select, dataSource, addBlank) {
    let newOption;
    if (addBlank) {
        select.appendChild(new Option('', ''));
    }
    if (dataSource && dataSource.length > 0) {
        dataSource.sort(function(a, b){
            if(a._name.toLowerCase() < b._name.toLowerCase()) { return -1; }
            if(a._name.toLowerCase() > b._name.toLowerCase()) { return 1; }
            return 0;
        });
    }
    $.each(dataSource, function (value, text) {
        newOption = new Option(text.name, JSON.stringify({
            id: text.id,
            name: text.name,
            description: text.description
        }));
        select.appendChild(newOption);
    });
}

const mapStateToProps = (state, ownProps) => {
    return {
        businessObjectsWrapper: state.boCore.businessObjectsWrapper,
        currentBusinessObject: ownProps.currentBusinessObject,
        currentRelationship: ownProps.currentRelationship
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        createBusinessObjectRelationship: (dto, args) => {
            dispatch(createBusinessObjectRelationship(dto, args));
        },
        updateBusinessObjectRelationship: (id, obj, args) => {
            dispatch(updateBusinessObjectRelationship(id, obj, args));
        },
        deleteBusinessObjectRelationship: (id, args) => {
            dispatch(deleteBusinessObjectRelationship(id, args));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(BusinessObjectRelationshipsGrid)



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/BusinessObjectRelationshipsGrid.tsx